import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'csl-rounding-input',
  templateUrl: './rounding-input.component.html',
})
export class RoundingInputComponent implements OnInit {
  _value = 0;

  @Input() editable = true;

  @Input() min = 0;
  @Input() max = 0;

  @Output() valueChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() set value(val: number) {
    this._value = val;
  }

  @Input()
  get dense() {
    return this._dense;
  }
  set dense(value: BooleanInput) {
    this._dense = coerceBooleanProperty(value);
  }
  _dense = false;

  constructor() {}

  ngOnInit(): void {}
}
